// extracted by mini-css-extract-plugin
export default {"container":"AssetPanelDetails_container__bb1t5","accordions":"AssetPanelDetails_accordions__PGHs8","map":"AssetPanelDetails_map__rqv4k"};